<template>
<div class="chapter">
<div class="inner_page">
<div class="ipadfp"><a id="page_v"><img alt="8 Seconds of Courage: A Soldier's Story from Immigrant to the Medal of Honor, by Flo Groberg and Tom Sileo. Simon &amp; Schuster." class="imagefp" src="images/title.jpg"/></a></div><a id="page_v">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?3821c56f